export var zeroRightClassName = 'right-scroll-bar-position';
export var fullWidthClassName = 'width-before-scroll-bar';
export var noScrollbarsClassName = 'with-scroll-bars-hidden';



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
// module id = 239
// module chunks = 0